import i18n from "@/plugins/vue-i18n";

const ContextualBundleListIndex = () =>
  import(
    // eslint-disable-next-line max-len
    /* webpackChunkName: "contextual" */ "@/views/admin/contextual-bundles/index/ContextualBundleListIndexPage.vue"
  );
const ContextualBundleListAdd = () =>
  import(
    /* webpackChunkName: "contextual" */ "@/views/admin/contextual-bundles/add/ContextualBundleListAddPage.vue"
  );
const ContextualBundleListEdit = () =>
  import(
    // eslint-disable-next-line max-len
    /* webpackChunkName: "contextual" */ "@/views/admin/contextual-bundles/edit/ContextualBundleListEditPage.vue"
  );

const contextualBundles = [
  {
    path: "contextual",
    name: "AdminContextualBundles",
    component: ContextualBundleListIndex,
    meta: {
      title: i18n.t("title.contextualBundles"),
    },
  },
  {
    path: "contextual/add",
    name: "AdminContextualBundleListAdd",
    component: ContextualBundleListAdd,
    meta: {
      title: i18n.t("title.contextualBundles"),
    },
  },
  {
    path: "contextual/:id/edit",
    name: "AdminContextualBundleListEdit",
    component: ContextualBundleListEdit,
    meta: {
      title: i18n.t("title.contextualBundles"),
    },
  },
];

export default contextualBundles;
